import { render, staticRenderFns } from "./weekly-extract.vue?vue&type=template&id=670f288c"
import script from "./weekly-extract.vue?vue&type=script&lang=js"
export * from "./weekly-extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports